<template>
  <header :class="[extendHeader ? 'quiz-header-overlap': 'quiz-header']">
    <div class="container-fluid">
      <ul>
        <li>
          <a
              class="h-back-link"
              data-toggle="modal"
              data-target=".exit-quiz-modal"
              v-on:click="handleBack()"
          >
            <img
            src="@/assets/back-light.png" alt="back" class="img-fluid">
          </a> <span style="font-size: 16px;"> {{quizDetailsTitle}}</span></li>
        <li v-if="showQuizHistoryMenu">
          <router-link
              class="h-history"
              to="/quiz-history"
          >
            <img src="@/assets/quiz-history.svg" alt="history" class="img-fluid">
          </router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>

import { globals } from "@/mixins/globals"
export default {
  mixins: [globals],
  name: 'quiz-header',
  props: {
    title: String,
    showAddTask: Boolean,
    extendHeader: Boolean
  },
  components: {},
  methods: {
    handleBack() {
      var currentUrl = window.location.pathname;
      if(currentUrl == "/play-quiz"){
        this.$store.state.showExitModal = true;
        return
      }
      this.$router.go(-1)
    },
  },
  computed: {
    homePage() {
      if (this.$route.path === '/') {
        return true
      } else {
        return false
      }
    },
  },
  created() {
    document.documentElement.style.setProperty('--bg-color', this.bgTheme);
  }
}
</script>

<style scoped>
  @import '../assets/quiz-styles/quiz-styles.css';
  @import '../assets/fonts/quiz-fonts/fonts.css';
</style>



// WEBPACK FOOTER //
// src/components/quiz-header.vue